import { Select } from "components/base/Form";
import PageV2 from "components/shared/PageV2";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ReportView from "./ReportView";

const SalesReportPage = () => {
  const currentYear = new Date().getFullYear();
  const defaultStartYear = currentYear - 2;
  const defaultEndYear = currentYear;
  const [searchParams, setSearchParams] = useSearchParams({
    reportType: "EXCLUDE_INC",
    startYear: String(defaultStartYear),
    endYear: String(defaultEndYear),
    currency: "USD",
  });
  const params = Object.fromEntries([...searchParams]);
  const startYear = Number(searchParams.get("startYear")) || defaultStartYear;
  const endYear = Number(searchParams.get("endYear")) || defaultEndYear;
  const currency = searchParams.get("currency") || "USD";
  const reportType = searchParams.get("reportType") || "EXCLUDE_INC";
  const yearOptions = Array.from({ length: 9 }, (_, i) => currentYear - 4 + i);

  useEffect(() => {
    const nextParams = { ...params };
    let changed = false;

    if (!searchParams.get("reportType")) {
      nextParams.reportType = "EXCLUDE_INC";
      changed = true;
    }
    if (!searchParams.get("startYear")) {
      nextParams.startYear = String(defaultStartYear);
      changed = true;
    }
    if (!searchParams.get("endYear")) {
      nextParams.endYear = String(defaultEndYear);
      changed = true;
    }

    if (changed) {
      setSearchParams(nextParams, { replace: true });
    }
  }, [defaultEndYear, defaultStartYear, params, searchParams, setSearchParams]);

  return (
    <PageV2
      title="Sales Reports"
      subtitle="Sales report from AB Odoo. Base on delivery schedule dates."
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Select
            value={searchParams.get("reportType")}
            onChange={(e) => {
              setSearchParams({ ...params, reportType: e.target.value });
            }}
          >
            <option value="EXCLUDE_INC">Exclude Waboba Inc</option>
            <option value="ALL">Include Waboba Inc</option>
          </Select>

          <div className="flex items-center gap-2">
            <Select
              value={startYear}
              onChange={(e) => {
                const nextStartYear = Number(e.target.value);
                setSearchParams({
                  ...params,
                  startYear: String(nextStartYear),
                  endYear: String(Math.max(nextStartYear, endYear)),
                });
              }}
            >
              {yearOptions.map((year) => (
                <option key={`start-${year}`} value={year}>
                  {year}
                </option>
              ))}
            </Select>
            <span className="opacity-60">to</span>
            <Select
              value={endYear}
              onChange={(e) => {
                const nextEndYear = Number(e.target.value);
                setSearchParams({
                  ...params,
                  startYear: String(Math.min(startYear, nextEndYear)),
                  endYear: String(nextEndYear),
                });
              }}
            >
              {yearOptions.map((year) => (
                <option key={`end-${year}`} value={year}>
                  {year}
                </option>
              ))}
            </Select>
          </div>
        </div>

        <div>
          <Select
            value={currency}
            onChange={(e) => {
              setSearchParams({ ...params, currency: e.target.value });
            }}
          >
            <option>USD</option>
            <option>SEK</option>
            <option>EUR</option>
            <option>CNY</option>
          </Select>
        </div>
      </div>

      <div className="relative flex-1">
        <ReportView
          startYear={startYear}
          endYear={endYear}
          reportType={reportType}
          currency={currency}
        />
      </div>
    </PageV2>
  );
};

export default SalesReportPage;
